import script from "./UserLabelDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserLabelDetailPage.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__